import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["factory"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from "react";
import { Utils } from "@react-awesome-query-builder/core";
import omit from "lodash/omit";
var getTitleInListValues = Utils.ListUtils.getTitleInListValues;
var _widgetDefKeysToOmit = Utils.ConfigUtils._widgetDefKeysToOmit;
export default (function (_ref) {
  var delta = _ref.delta,
    isFuncArg = _ref.isFuncArg,
    valueSrc = _ref.valueSrc,
    immValue = _ref.value,
    immValueError = _ref.valueError,
    asyncListValues = _ref.asyncListValues,
    isSpecialRange = _ref.isSpecialRange,
    fieldDefinition = _ref.fieldDefinition,
    widget = _ref.widget,
    widgetDefinition = _ref.widgetDefinition,
    widgetValueLabel = _ref.widgetValueLabel,
    valueLabels = _ref.valueLabels,
    textSeparators = _ref.textSeparators,
    setValueHandler = _ref.setValueHandler,
    config = _ref.config,
    field = _ref.field,
    fieldSrc = _ref.fieldSrc,
    fieldType = _ref.fieldType,
    isLHS = _ref.isLHS,
    operator = _ref.operator,
    readonly = _ref.readonly,
    parentField = _ref.parentField,
    parentFuncs = _ref.parentFuncs,
    id = _ref.id,
    groupId = _ref.groupId;
  var widgetFactory = widgetDefinition.factory,
    fieldWidgetProps = _objectWithoutProperties(widgetDefinition, _excluded);
  var isConst = isFuncArg && fieldDefinition.valueSources && fieldDefinition.valueSources.length == 1 && fieldDefinition.valueSources[0] == "const";
  var defaultValue = fieldDefinition.defaultValue;
  if (!widgetFactory) {
    return "?";
  }
  var value = isSpecialRange ? [immValue.get(0), immValue.get(1)] : immValue ? immValue.get(delta) : undefined;
  var valueError = immValueError && (isSpecialRange ? [immValueError.get(0), immValueError.get(1)] : immValueError.get(delta)) || null;
  if (isSpecialRange && value[0] === undefined && value[1] === undefined) value = undefined;
  var _ref2 = fieldDefinition || {},
    fieldSettings = _ref2.fieldSettings;
  var widgetProps = omit(_objectSpread(_objectSpread(_objectSpread({}, fieldWidgetProps), fieldSettings), {}, {
    config: config,
    field: field,
    fieldSrc: fieldSrc,
    fieldType: fieldType,
    isLHS: isLHS,
    parentField: parentField,
    parentFuncs: parentFuncs,
    fieldDefinition: fieldDefinition,
    operator: operator,
    delta: delta,
    isSpecialRange: isSpecialRange,
    isFuncArg: isFuncArg,
    value: value,
    valueError: valueError,
    label: widgetValueLabel.label,
    placeholder: widgetValueLabel.placeholder,
    placeholders: valueLabels ? valueLabels.placeholder : null,
    textSeparators: textSeparators,
    setValue: setValueHandler,
    readonly: readonly,
    asyncListValues: asyncListValues,
    id: id,
    groupId: groupId
  }), [].concat(_toConsumableArray(_widgetDefKeysToOmit), ["toJS"]));
  if (widget == "field") {
    //
  }
  if (isConst && defaultValue) {
    var listValues = (fieldSettings === null || fieldSettings === void 0 ? void 0 : fieldSettings.treeValues) || (fieldSettings === null || fieldSettings === void 0 ? void 0 : fieldSettings.listValues);
    if (typeof defaultValue == "boolean") {
      return defaultValue ? widgetProps.labelYes || "YES" : widgetProps.labelNo || "NO";
    } else if (listValues) {
      if (Array.isArray(defaultValue)) return defaultValue.map(function (v) {
        return getTitleInListValues(listValues, v) || v;
      }).join(", ");else return getTitleInListValues(listValues, defaultValue) || defaultValue;
    }
    return "" + defaultValue;
  }
  return widgetFactory(widgetProps, config.ctx);
});